import { RequestScheduleType } from '../../../../common/models/request-schedule.model';

export const WEEK_DAYS: { label: string; value: string }[] = [
  { label: 'Monday', value: 'monday' },
  { label: 'Tuesday', value: 'tuesday' },
  { label: 'Wednesday', value: 'wednesday' },
  { label: 'Thursday', value: 'thursday' },
  { label: 'Friday', value: 'friday' },
  { label: 'Saturday', value: 'saturday' },
  { label: 'Sunday', value: 'sunday' },
];

export const SCHEDULE_TYPE_OPTIONS: {
  label: string;
  value: RequestScheduleType;
}[] = [
  { label: 'schedule_type_one_time_option', value: RequestScheduleType.ONE_TIME },
  { label: 'schedule_type_daily_option', value: RequestScheduleType.DAILY },
  { label: 'schedule_type_weekly_option', value: RequestScheduleType.WEEKLY },
  { label: 'schedule_type_monthly_option', value: RequestScheduleType.MONTHLY },
  { label: 'schedule_type_yearly_option', value: RequestScheduleType.YEARLY },
];
